<template>
  <div class="contenedor-editar-datos-socio">
    <div class="contenedor-titulo">
      <h1>Cargar Resultado Examen</h1>
      <div class="barra"></div>
    </div>
    <router-link :to="`/datos-inscripcion-examen/${this.$route.params.id}`" class="boton_volver_login"><span>&#8592;</span> Atrás</router-link>
    <section>
      <div class="contenedor-editar-datos-socio-izquierda">
        <img src="@/assets/patanjali.jpg" alt="Patanjali">
      </div>
      <div class="contenedor-editar-datos-socio-derecha">
        <form
          action="#"
          method="post"
          @submit.prevent="cargarExamen(examen)"
          class="form_presupuesto_nuevo"
        >
          <div class="form_section_editar_socio">
            <label for="fecha_examen">Fecha</label>
              <input
                type="date"
                name="fecha_examen"
                id="fecha_examen"
                v-model="examen.fecha_examen"
                :disabled="cargando"
              >
              <div
              class="form_mensaje_error_crear_pago"
                v-if="errores.fecha_examen !== null"
              >
                {{ errores.fecha_examen[0] }}
              </div>
          </div>
          <div class="form_section_editar_socio">
            <label for="perfil_id">Certificación</label>
            <select
              id="certificacion_id"
              name="certificacion_id"
              class="form minimal"
              v-model.number="examen.certificacion_id"
              :disabled="cargando"
            >
              <option
                v-for="certificacion in certificaciones"
                :value="certificacion.certificacion_id"
                :key="certificacion.certificacion_id"
              >
                {{ certificacion.nombre }}
              </option>
            </select>
            <div
            class="form_editar_mensaje_error"
              v-if="errores.certificacion_id !== null"
            >
              {{ errores.certificacion_id[0] }}
            </div>
          </div>
          <div class="form_section_editar_socio">
            <label for="imagen" class="boton_cambiar_foto">Subir planilla de puntaje</label>
            <input
              type="file"
              accept=".png,.jpg,.jpeg,.PNG,.JPG,.JPEG"
              id="imagen"
              ref="imagen"
              @change="encodeImage"
            >
          </div>
          <div class="form_section_editar_socio">
            <label for="imagen2" class="boton_cambiar_foto">Subir carta de devolución</label>
            <input
              type="file"
              accept=".png,.jpg,.jpeg,.PNG,.JPG,.JPEG"
              id="imagen2"
              ref="imagen2"
              @change="encodeImage2"
            >
          </div>
          <!-- <div class="form_section_editar_socio">
            <label for="email">Email</label>
            <input
              type="text"
              name="email"
              id="email"
              v-model="socio.email"
              :disabled="cargando"
            >
            <div
            class="form_editar_mensaje_error"
              v-if="errores.email !== null"
            >
              {{ errores.email[0] }}
            </div>
          </div>
          <div class="form_section_editar_socio">
            <label for="dni">DNI</label>
            <input
              type="text"
              name="dni"
              id="dni"
              v-model="socio.dni"
              :disabled="cargando"
            >
            <div
              class="form_editar_mensaje_error"
              v-if="errores.dni !== null"
            >
              {{ errores.dni[0] }}
            </div>
          </div>

          <div class="form_section_editar_socio">
            <label for="perfil_id">Perfil</label>
            <select
              id="perfil_id"
              name="perfil_id"
              class="form minimal"
              v-model.number="socio.perfil_id"
              :disabled="cargando"
            >
              <option
                v-for="perfil in perfiles"
                :value="perfil.perfil_id"
                :key="perfil.perfil_id"
              >
                {{ perfil.nombre }}
              </option>
            </select>
            <div
            class="form_editar_mensaje_error"
              v-if="errores.perfil_id !== null"
            >
              {{ errores.perfil_id[0] }}
            </div>
          </div>
          <div class="form_section_editar_socio">
            <label for="fecha_ingreso">Fecha de Ingreso</label>
            <input
              type="date"
              name="fecha_ingreso"
              id="fecha_ingreso"
              v-model="socio.fecha_ingreso"
              :disabled="cargando"
            >
            <div
            class="form_editar_mensaje_error"
              v-if="errores.fecha_ingreso !== null"
            >
              {{ errores.fecha_ingreso[0] }}
            </div>
          </div> -->
          <button type="submit" class="boton_guardar">Cargar</button>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
import personasService from '../services/personas'
import examenService from '../services/examen'
// import Menu from '../components/Menu.vue'
// import Footer from '../components/Footer.vue'

export default {
  name: 'CargarResultadoExamen',
  components: {
  },
  data: function () {
    return {
      perfiles: [],
      certificaciones: [],
      years: [],
      formasDePago: [],
      personas: [],
      monedas: [],
      cargando: false,
      // show: true,
      // seleccionado: 5,
      examen: {
        fecha_examen: null,
        certificacion_id: null,
        planilla_puntaje: null,
        carta_devolucion: null
      },
      errores: {
        fecha_examen: null,
        certificacion_id: null
      }
    }
  },
  methods: {
    encodeImage () {
      const extensiones = this.$refs.imagen.value.substring(this.$refs.imagen.value.lastIndexOf('.'), this.$refs.imagen.value.lenght)
      if (this.$refs.imagen.getAttribute('accept').split(',').indexOf(extensiones) < 0) {
        console.log('Formato incorrecto')
      } else if (this.$refs.imagen.files[0].size > 1200000) {
        console.log('Pesadaaaaao')
      } else {
        console.log('rrrrrrrrr')
        // const file = e.target.files[0]
        const file = this.$refs.imagen.files[0]
        // this.examen.planilla_puntaje = URL.createObjectURL(file)
        const reader = new FileReader()
        reader.addEventListener('load', () => {
          this.examen.planilla_puntaje = reader.result
          console.log('FILE:', reader.result)
        })
        reader.readAsDataURL(file)
      }
    },
    encodeImage2 () {
      const extensiones = this.$refs.imagen2.value.substring(this.$refs.imagen2.value.lastIndexOf('.'), this.$refs.imagen2.value.lenght)
      if (this.$refs.imagen2.getAttribute('accept').split(',').indexOf(extensiones) < 0) {
        console.log('Formato incorrecto')
      } else if (this.$refs.imagen2.files[0].size > 1200000) {
        console.log('Pesadaaaaao')
      } else {
        console.log('rrrrrrrrr')
        // const file = e.target.files[0]
        const file = this.$refs.imagen2.files[0]
        // this.examen.planilla_puntaje = URL.createObjectURL(file)
        const reader = new FileReader()
        reader.addEventListener('load', () => {
          this.examen.carta_devolucion = reader.result
          console.log('FILE:', reader.result)
        })
        reader.readAsDataURL(file)
      }
    },
    cargarExamen (examen) {
      console.log('qqqq')
      console.log(examen)
      if (this.cargando) {
        return null
      }
      // Reafirmo que el perfil visitante tenga certificacion 1
      // if (this.socio.perfil_id === 2) {
      //   this.socio.certificacion_id = 1
      // }
      this.errores = {
        fecha_examen: null,
        certificacion_id: null,
        planilla_puntaje: null
      }
      this.cargando = true
      examenService
        .cargarExamen(examen)
        .then(respuesta => {
          this.cargando = false
          if (respuesta.success) {
            console.log('SIIIIII')
            this.examen = {
              fecha_examen: null,
              certificacion_id: null,
              planilla_puntaje: null,
              carta_devolucion: null
            }
            this.errores = {
              fecha_examen: null,
              certificacion_id: null
            }
            // this.$router.push('/presupuesto')
          } else {
            this.errores = {
              fecha_examen: null,
              certificacion_id: null,
              ...respuesta.errors
            }
          }
        })
    }
  },
  mounted: function () {
    console.log('aaaassssssaaaa')
    console.log(this.$route.query.collection_id)
    console.log(this.$route.query.pepe)
    personasService
      .traerPerfilesTodos()
      .then(respuesta => {
        // this.cargando = false
        this.perfiles = respuesta
      })
    personasService
      .traerCertificacionesTodas()
      .then(respuesta => {
        // this.cargando = false
        this.certificaciones = respuesta
      })
  },
  computed: {
  }
}
</script>
